<template>
  <div class="site-page site-page--fluid nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">我的创作</h1>
      <p class="hint">管理您创建的课程与测评。新建或修改后需管理员审核通过，才会出现在公开列表；您可随时预览、上下架（上下架不改变审核状态）。</p>

      <el-tabs v-model="tab">
        <el-tab-pane label="课程" name="course">
          <div class="course-toolbar">
            <el-button type="primary" @click="$router.push('/creator/knowledge/courses/simple')">
              新建简易课程
            </el-button>
          </div>
          <el-table :data="courses" v-loading="loading" empty-text="暂无课程">
            <el-table-column label="封面" width="100">
              <template #default="s">
                <img
                  v-if="bannerUrl(s.row.banner)"
                  :src="bannerUrl(s.row.banner)"
                  class="course-thumb"
                  alt=""
                />
                <span v-else class="course-thumb course-thumb--empty">无图</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" min-width="160" />
            <el-table-column prop="category" label="分类" width="120" />
            <el-table-column label="定价（元）" width="100">
              <template #default="s">{{ (s.row.fee / 100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column label="审核" width="110">
              <template #default="s">
                <el-tag :type="auditTag(s.row.auditStatus)" size="small">{{ auditText(s.row.auditStatus) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="上架" width="80">
              <template #default="s">
                <el-tag :type="Number(s.row.state) === 1 ? 'success' : 'info'" size="small">
                  {{ Number(s.row.state) === 1 ? '上架' : '已下架' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="420">
              <template #default="s">
                <el-button link type="primary" @click="previewCourse(s.row)">预览</el-button>
                <el-button
                  v-if="Number(s.row.state) === 1"
                  link
                  type="warning"
                  :loading="courseStateSavingId === s.row.kcId"
                  @click="setCourseState(s.row, 0)"
                >下架</el-button>
                <el-button
                  v-else
                  link
                  type="success"
                  :loading="courseStateSavingId === s.row.kcId"
                  @click="setCourseState(s.row, 1)"
                >上架</el-button>
                <el-button link type="primary" @click="openRedeemCodes(s.row)">兑换码</el-button>
                <el-button link type="primary" @click="goSimpleEdit(s.row)">简易编辑</el-button>
                <el-button link type="primary" @click="goManageCourse(s.row)">知识点</el-button>
                <el-button link type="primary" @click="goManageResources(s.row)">资源</el-button>
                <el-button link type="danger" @click="deleteCourse(s.row)">删除整课</el-button>
              </template>
            </el-table-column>
          </el-table>
          <p v-if="courses.some(c => c.auditStatus === 2 && c.auditMessage)" class="exam-reject-hint">
            课程审核驳回时，可简易编辑后重新提交；通过后才会出现在公开列表。
          </p>
        </el-tab-pane>
        <el-tab-pane label="测评" name="exam">
          <div class="course-toolbar">
            <el-button type="primary" @click="$router.push('/creator/exam/create')">新增测评</el-button>
            <span class="exam-toolbar-note">新建后需管理员审核通过，才会出现在公开列表。</span>
          </div>
          <el-table :data="exams" v-loading="loading" empty-text="暂无测评">
            <el-table-column label="缩略图" width="90">
              <template #default="s">
                <img v-if="s.row.thumb" :src="s.row.thumb" class="course-thumb" alt="" />
                <span v-else class="course-thumb course-thumb--empty">无图</span>
              </template>
            </el-table-column>
            <el-table-column prop="examName" label="名称" min-width="160" />
            <el-table-column prop="examSname" label="简称" width="110" />
            <el-table-column label="定价（元）" width="100">
              <template #default="s">{{ (s.row.fee / 100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column label="审核" width="110">
              <template #default="s">
                <el-tag :type="auditTag(s.row.auditStatus)" size="small">{{ auditText(s.row.auditStatus) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="上架" width="80">
              <template #default="s">
                <el-tag :type="Number(s.row.state) === 1 ? 'success' : 'info'" size="small">
                  {{ Number(s.row.state) === 1 ? '上架' : '已下架' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="420" fixed="right">
              <template #default="s">
                <el-button link type="primary" @click="$router.push(`/exam/${s.row.id}`)">预览</el-button>
                <el-button link type="primary" @click="$router.push(`/exam/take/${s.row.id}`)">试测</el-button>
                <el-button link type="primary" @click="$router.push(`/creator/exam/${s.row.id}/results`)">测试结果</el-button>
                <el-button link type="primary" @click="openExamRedeemCodes(s.row)">兑换码</el-button>
                <el-button link type="warning" @click="$router.push(`/creator/exam/edit/${s.row.id}`)">编辑</el-button>
                <el-button
                  v-if="Number(s.row.state) === 1"
                  link
                  type="warning"
                  :loading="stateSavingId === s.row.id"
                  @click="setExamState(s.row, 0)"
                >下架</el-button>
                <el-button
                  v-else
                  link
                  type="success"
                  :loading="stateSavingId === s.row.id"
                  @click="setExamState(s.row, 1)"
                >上架</el-button>
                <el-button
                  v-if="Number(s.row.removed) === 1"
                  link
                  type="success"
                  :loading="removedSavingId === s.row.id"
                  @click="setExamRemoved(s.row, 0)"
                >恢复</el-button>
                <el-button
                  v-else
                  link
                  type="danger"
                  @click="deleteExam(s.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <p v-if="exams.some(e => e.auditStatus === 2 && e.auditMessage)" class="exam-reject-hint">
            审核驳回时，可在编辑页查看驳回原因并修改后重新提交。
          </p>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      v-model="redeemVisible"
      :title="redeemDialogTitle"
      width="760px"
    >
      <p class="hint">{{ redeemDialogHint }}</p>
      <div class="redeem-create">
        <el-input-number v-model="redeemCount" :min="1" :max="20" />
        <el-input v-model="redeemNote" placeholder="备注，可选" maxlength="128" />
        <el-button type="primary" :loading="redeemCreating" @click="createRedeemCodes">生成</el-button>
      </div>
      <el-table :data="redeemCodes" v-loading="redeemLoading" empty-text="还没有兑换码">
        <el-table-column prop="code" label="兑换码" width="150" />
        <el-table-column label="状态" width="90">
          <template #default="s">{{ redeemStatusText(s.row.status) }}</template>
        </el-table-column>
        <el-table-column prop="note" label="备注" min-width="100" />
        <el-table-column label="核销人" min-width="110">
          <template #default="s">{{ s.row.redeemedByName || '—' }}</template>
        </el-table-column>
        <el-table-column label="核销时间" width="170">
          <template #default="s">{{ formatRedeemTime(s.row.redeemedAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template #default="s">
            <el-button
              v-if="s.row.status === 'unused'"
              link
              type="danger"
              @click="disableRedeemCode(s.row)"
            >停用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { fetchMyCreations } from '@/utils/userHub'
import { photoPathToUrl } from '@/utils/photoUpload'
import { bumpExamListCache } from '@/utils/listPageCache'
import axios from 'axios'

export default {
  name: 'MyCreationsView',
  data() {
    return {
      tab: 'course',
      loading: false,
      exams: [],
      courses: [],
      stateSavingId: 0,
      courseStateSavingId: 0,
      removedSavingId: 0,
      redeemVisible: false,
      redeemKind: 'course',
      redeemTarget: null,
      redeemCodes: [],
      redeemLoading: false,
      redeemCreating: false,
      redeemCount: 1,
      redeemNote: ''
    }
  },
  computed: {
    redeemDialogTitle() {
      if (!this.redeemTarget) return '兑换码'
      const name = this.redeemKind === 'exam'
        ? (this.redeemTarget.examName || '测评')
        : (this.redeemTarget.name || '课程')
      return `${name} · 兑换码`
    },
    redeemDialogHint() {
      if (this.redeemKind === 'exam') {
        return '生成后发给用户。用户在测评页核销后，这里显示核销人和时间。核销后可以测评，和余额购买分开记录，不会按购买给你结算。'
      }
      return '生成后发给用户。用户在课程页核销后，这里显示核销人和时间。核销后可以学习，和余额购买分开记录，不会按购买给你结算。'
    }
  },
  created() {
    if (this.$route.query.tab === 'exam') {
      this.tab = 'exam'
    }
    this.load()
  },
  methods: {
    bannerUrl(banner) {
      return photoPathToUrl(banner || '')
    },
    authHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        'Content-Type': 'application/json'
      }
    },
    auditText(status) {
      return { 0: '待审核', 1: '已通过', 2: '已驳回' }[Number(status)] || '未知'
    },
    auditTag(status) {
      return { 0: 'warning', 1: 'success', 2: 'danger' }[Number(status)] || 'info'
    },
    async setExamState(row, next) {
      this.stateSavingId = row.id
      try {
        const res = await axios.post(
          '/api/v1/admin/exam/state',
          { examId: row.id, state: next },
          { headers: this.authHeaders() }
        )
        if (res.data.code === 200) {
          row.state = next
          bumpExamListCache()
          ElMessage.success(res.data.message || (next ? '已上架' : '已下架'))
        } else {
          ElMessage.error(res.data.message || '操作失败')
        }
      } catch {
        ElMessage.error('操作失败')
      } finally {
        this.stateSavingId = 0
      }
    },
    async setExamRemoved(row, next) {
      this.removedSavingId = row.id
      try {
        const res = await axios.post(
          '/api/v1/admin/exam/removed',
          { examId: row.id, removed: next },
          { headers: this.authHeaders() }
        )
        if (res.data.code === 200) {
          row.removed = next
          bumpExamListCache()
          ElMessage.success(res.data.message || (next ? '已删除' : '已恢复'))
          this.load()
        } else {
          ElMessage.error(res.data.message || '操作失败')
        }
      } catch {
        ElMessage.error('操作失败')
      } finally {
        this.removedSavingId = 0
      }
    },
    async deleteExam(row) {
      try {
        await ElMessageBox.confirm(
          `将「${row.examName}」标记为删除，公开列表不再展示，可在本页恢复。`,
          '删除测评',
          { type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消' }
        )
      } catch {
        return
      }
      await this.setExamRemoved(row, 1)
    },
    goManageCourse(row) {
      this.$router.push({ path: '/creator/knowledge/points', query: { kcId: row.kcId } })
    },
    goManageResources(row) {
      this.$router.push({ path: '/creator/knowledge/resources', query: { kcId: row.kcId } })
    },
    goSimpleEdit(row) {
      this.$router.push({ path: '/creator/knowledge/courses/simple', query: { kcId: row.kcId } })
    },
    previewCourse(row) {
      this.$router.push({
        path: `/knowledge/courses/display/${row.kcId}`,
        query: { from: 'works' }
      })
    },
    async setCourseState(row, next) {
      this.courseStateSavingId = row.kcId
      try {
        const res = await axios.post(
          '/api/v1/knowledge/courses/state',
          { kcId: row.kcId, state: next },
          { headers: this.authHeaders() }
        )
        if (res.data.code === 200) {
          row.state = next
          ElMessage.success(res.data.message || (next ? '已上架' : '已下架'))
        } else {
          ElMessage.error(res.data.message || '操作失败')
        }
      } catch {
        ElMessage.error('操作失败')
      } finally {
        this.courseStateSavingId = 0
      }
    },
    async deleteCourse(row) {
      try {
        await ElMessageBox.confirm(
          `确定删除「${row.name}」整门课程？将一并删除全部课时与资源，不可恢复。`,
          '删除整门课',
          { type: 'warning', confirmButtonText: '全部删除', cancelButtonText: '取消' }
        )
      } catch {
        return
      }
      try {
        const token = localStorage.getItem('jwt_token')
        const res = await fetch('/api/v1/knowledge/courses/delete', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ kcId: row.kcId })
        })
        const data = await res.json()
        if (data.code !== 200) {
          ElMessage.error(data.message || '删除失败')
          return
        }
        ElMessage.success('已删除')
        this.load()
      } catch (e) {
        ElMessage.error('删除失败')
      }
    },
    redeemStatusText(status) {
      return { unused: '未使用', redeemed: '已核销', disabled: '已停用' }[status] || status
    },
    formatRedeemTime(ts) {
      if (!ts) return '—'
      const date = new Date(Number(ts) * 1000)
      if (Number.isNaN(date.getTime())) return '—'
      return date.toLocaleString('zh-CN', { hour12: false })
    },
    async openRedeemCodes(row) {
      this.redeemKind = 'course'
      this.redeemTarget = row
      this.redeemVisible = true
      this.redeemCount = 1
      this.redeemNote = ''
      await this.loadRedeemCodes()
    },
    async openExamRedeemCodes(row) {
      this.redeemKind = 'exam'
      this.redeemTarget = row
      this.redeemVisible = true
      this.redeemCount = 1
      this.redeemNote = ''
      await this.loadRedeemCodes()
    },
    async loadRedeemCodes() {
      if (!this.redeemTarget) return
      this.redeemLoading = true
      try {
        const isExam = this.redeemKind === 'exam'
        const url = isExam
          ? '/api/v1/exam/redeem-code/list'
          : '/api/v1/knowledge/courses/redeem-code/list'
        const body = isExam
          ? { examId: this.redeemTarget.id }
          : { kcId: this.redeemTarget.kcId }
        const res = await axios.post(url, body, { headers: this.authHeaders() })
        if (res.data.code === 200) {
          this.redeemCodes = res.data.data?.codes || []
        } else {
          ElMessage.error(res.data.message || '加载兑换码失败')
        }
      } catch (e) {
        ElMessage.error('加载兑换码失败')
      } finally {
        this.redeemLoading = false
      }
    },
    async createRedeemCodes() {
      if (!this.redeemTarget) return
      this.redeemCreating = true
      try {
        const isExam = this.redeemKind === 'exam'
        const url = isExam
          ? '/api/v1/exam/redeem-code/create'
          : '/api/v1/knowledge/courses/redeem-code/create'
        const body = isExam
          ? { examId: this.redeemTarget.id, count: this.redeemCount, note: this.redeemNote }
          : { kcId: this.redeemTarget.kcId, count: this.redeemCount, note: this.redeemNote }
        const res = await axios.post(url, body, { headers: this.authHeaders() })
        if (res.data.code === 200) {
          ElMessage.success(res.data.message || '已生成')
          this.redeemNote = ''
          await this.loadRedeemCodes()
        } else {
          ElMessage.error(res.data.message || '生成失败')
        }
      } catch (e) {
        ElMessage.error('生成失败')
      } finally {
        this.redeemCreating = false
      }
    },
    async disableRedeemCode(row) {
      try {
        await ElMessageBox.confirm(`停用兑换码 ${row.code}？停用后不能再核销。`, '停用兑换码', {
          confirmButtonText: '停用',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      try {
        const url = this.redeemKind === 'exam'
          ? '/api/v1/exam/redeem-code/disable'
          : '/api/v1/knowledge/courses/redeem-code/disable'
        const res = await axios.post(url, { id: row.id }, { headers: this.authHeaders() })
        if (res.data.code === 200) {
          ElMessage.success(res.data.message || '已停用')
          await this.loadRedeemCodes()
        } else {
          ElMessage.error(res.data.message || '停用失败')
        }
      } catch (e) {
        ElMessage.error('停用失败')
      }
    },
    async load() {
      this.loading = true
      try {
        const data = await fetchMyCreations()
        this.exams = data.exams || []
        this.courses = data.courses || []
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.hint { color: #666; margin-bottom: 16px; }
.course-toolbar { margin-bottom: 12px; }
.course-thumb {
  width: 72px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
  background: #f2f3f5;
}
.course-thumb--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #909399;
}
.exam-toolbar-note {
  margin-left: 12px;
  font-size: 13px;
  color: #909399;
}
.exam-reject-hint {
  margin-top: 10px;
  font-size: 13px;
  color: #909399;
}
.redeem-create {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
}
.redeem-create .el-input {
  flex: 1;
}
</style>
